import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';

export const branchService = {
    getAll,
    getById,
    create,
    update,
    remove
};

function create(body) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/branch`, requestOptions).then(handleResponse);
}

function update(body) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/branch/`+body._id, requestOptions).then(handleResponse);
}

function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let url = Config.api.basepath+`/branch?`;

    url = options.page ? url + `page=` + options.page : url
    url = options.items ? url + `&per-page=` + options.items : url
    url = options.limit ? url + `&limit=` + options.limit : url;

    let filter = options.filter && Object.keys(options.filter).reduce(function (r, k) {
        return r.concat(k + ':' + options.filter[k]);
    }, []);

    url = options.filter ? url + `&filter=` + filter : url;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            branches => {
                let pages = parseInt(branches.total / branches['per-page']);
                pages = branches.total > ( pages * branches['per-page'] ) ? pages + 1 : pages;

                branches.pages = pages;

                return branches;
            },
            error => {
                return {error: 'Fetch devices Error. Service Unavailable.'};
            }
        );
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/branch/`+id, requestOptions).then(handleResponse);
}

function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/branch/`+id, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            let error = (data && data.message) || response.statusText;

            if( data.error && data.error.code === 11000){
                error = 'Branch already exists.';
            }

            return Promise.reject(error);
        }

        return data;
    });
}
